/**
 * eid-chatbot: shared EmpowerIQ chatbot UI and floating trigger.
 * Config is read from window.config (set per app in index.html).
 * CHATBOT_ENABLED controls visibility; other CHATBOT_* keys configure server, tenant, etc.
 */
export { default as ChatBot } from './ChatBot'
export { default as ChatBotFloatingTrigger } from './ChatBotFloatingTrigger'
export {
    chatbotEnabled,
    chatbotEnableVoiceDocs,
    chatbotEnableVoiceAgent,
    chatbotTranscribeUrlDocs,
    chatbotTranscribeUrlAgent,
    chatbotTranscribeUrl,
    chatbotEnableVoice,
    isChatbotVoiceEnabledForMode,
    getChatbotTranscribeUrlForMode,
    chatbotConfig,
    chatbotExplainShortcutKey,
} from './config'
export * from './types'
export {
    getElementExplainContext,
    buildExplainPrompt,
} from './explainUtils'
